export default __webpack_public_path__ + "media/src/usersite/images/header/sns_banners/sp_sns_tab-7cc1a9710b71819e18cadb7f2d520c95.png";